(function() {
    const authEl = document.getElementById("auth-check");
    const correctHash = authEl.dataset.hash;
    authEl.remove();
    
    async function sha256(str) {
        const buffer = new TextEncoder().encode(str);
        const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    }
    
    const form = document.getElementById("access-form");
    const submitBtn = form.querySelector(".btn.submit")
    submitBtn.addEventListener("click", async function(e) {
        e.preventDefault();
        await handleSubmission();
    });

    const input = form.querySelector(".input input");
    input.addEventListener("keydown", async function(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            await handleSubmission();
        }
    });

    async function handleSubmission() {
        const submission = input.value;
        if (!submission) { return }
        if (submission.trim() == "") { return }

        if (!submission.includes('@')) {
            const inputHash = await sha256(submission);
            if (inputHash === correctHash) {
                window.location.href = '/password?password=' + submission;
                return;
            } else {
                alert('Nah, girl. Please.');
                return;
            }
        }
      
        // It's an email, submit the form.
        form.submit();
    }

    // Handle Submission Success / Failure
    const urlParams = new URLSearchParams(window.location.search);
    const hash = window.location.hash;
    if (hash === '#contact_form') {
        const h3 = form.querySelector("h3"); 
        if (urlParams.get('customer_posted') === 'true') {
            form.classList.add("success");
            h3.innerHTML = "Received! We'll be in touch. ✨";
            h3.classList.add("highlighter", "theme--pickle");
        } else if (urlParams.get('form_type') === 'customer') {
            form.classList.add("error");
            h3.innerHTML = "Please enter a valid email."
            h3.classList.add("highlighter", "theme--grapefruit");
        }
    }
  })();